var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-pagination",
    _vm._b(
      {
        staticClass: "OPZPage",
        attrs: {
          background: _vm.background,
          "page-size": _vm.pageSize,
          total: _vm.total,
          "page-count": _vm.pageCount,
          layout: "sizes,prev, pager, next, jumper, ->, total",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      },
      "el-pagination",
      _vm.$attrs,
      false,
      true
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }